import { find, get, map, filter } from 'lodash'
import abilityPlugin from './plugins/ability'
import { vuexORMPlugin, mapAbilities } from './plugins/vuex-orm'
import { ormConfig } from '~/const/global'
import routes from '~/const/routes'

export const plugins = [vuexORMPlugin(), abilityPlugin]

export const state = () => ({})

export const mutations = {
  AFTER_GET_ALL(state, { namespace, items, meta, params }) {
    state[namespace].items = items
    state[namespace].meta = meta
    state[namespace].requestParams = params
  },
  AFTER_READ(state, { namespace, item }) {
    const items = get(state[namespace], 'items', [])
    const isUpdate = find(items, i => i.id === item.id)
    if (isUpdate) {
      state[namespace].items = map(items, i => (i.id === item.id ? item : i))
    } else {
      state[namespace].items.push(item)
    }
  },
  AFTER_CREATE(state, { namespace, item }) {
    state[namespace].items.push(item)
  },
  AFTER_UPDATE(state, { namespace, item }) {
    const items = get(state[namespace], 'items', [])
    state[namespace].items = map(items, i => (i.id === item.id ? item : i))
  },
  AFTER_DELETE(state, { namespace, id }) {
    state[namespace].items = filter(state[namespace].items, item => item.id !== id)
  }
}

export const getters = {
  user(state) {
    return state.user
  },
  profile(state) {
    return state.user.profile
  },
  isAuthenticated(state) {
    return !!state.user.token && !!state.user.profile
  },
  ability(state) {
    return state.ability.update(
      mapAbilities(state.user.rules, ormConfig, process.env.mock.abilities)
    )
  }
}

export const actions = {
  async synchronizeOrganization({ commit }, payload) {
    return await this.$axios.put(routes.organization.synchronize(payload.id), payload.data)
  },
  resetStores({ commit }) {
    commit('organizations/RESET')
    commit('comments/RESET')
    commit('folders/RESET')
    commit('documents/RESET')
    commit('templates/RESET')
    commit('participants/RESET')
    commit('billing/RESET')
    commit('acts/RESET')
    commit('invoices/RESET')
    commit('accesstokens/RESET')
    commit('organizationusers/RESET')
    commit('adminacts/RESET')
    commit('payments/RESET')
    commit('taxbills/RESET')
    commit('admininvoices/RESET')
    commit('admindocuments/RESET')
    commit('clientbalances/RESET')
    commit('users/RESET')
    commit('sessions/RESET')
    commit('admintemplates/RESET')
    commit('admintags/RESET')
    commit('adminorganizations/RESET')
    commit('adminparticipants/RESET')
    commit('documentlogs/RESET')
    commit('adminperiods/RESET')
    commit('documentstatuses/RESET')
    commit('admintariffs/RESET')
    commit('adminorganizationusers/RESET')
    commit('signatures/RESET')
    commit('tags/RESET')
    commit('documenttypes/RESET')
    commit('integrations/RESET')
    commit('adminsignatures/RESET')
    commit('archivetriggers/RESET')
    commit('peopleforce/RESET')
    commit('savedroutes/RESET')
    commit('profilemenu/RESET')
  }
}
